// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Xooy","footer":"ChangeClinic_footer__7-32F"};